module.exports = __webpack_public_path__ + "img/PT.89c41349.svg";